module.exports = __webpack_public_path__ + "fc8e0c3228eb29a97dd644132f15a6bb.pdf";